import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { 
	GetLocal,
	FetchService
} from "../../../Base/BaseControl";

export default function Index(props) {

	const [getServiceResult, setServiceResult] = useState(false);
	const [showModal, setShowModal] = useState(false);	
	const [getPdf, setPdf] = useState('');	
	

    useEffect(() => {
        var inputValue = {
            session: GetLocal('OwnersSession')
        };
        FetchService("Owner/Residential/Request/ShowLetters", inputValue, ShowLettersSuccess);
    }, []);	

	const ShowLettersSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult.LetterList);
	}	
	
	const PrintAction =(row)=>{
        var inputValue = {
			  session: GetLocal('OwnersSession'),
			  letterNumber: row.LetterNumber		  
        };
        FetchService("Owner/Residential/Request/GetLetter", inputValue, GetLetterSuccess, GetRequestsReviewFail);	
	}
	
	const GetLetterSuccess =(ServiceResult)=>{
		setPdf("data:application/pdf;base64,"+ServiceResult);
		setShowModal(true)
	}	

	const GetRequestsReviewFail =(ServiceResult)=>{
		setShowModal(false)
	}		

    return (
        <div>									
			<GridControl
				data={getServiceResult}
				customHeaders={{"LetterTitle": "نامه","LetterNumber": "شماره نامه","LetterDate": "تاریخ نامه","PrintAction":"چاپ"}}
				PrintAction={PrintAction}  					
			/>
			
			<Modal dialogClassName="modalUi" show={showModal} onHide={()=>setShowModal(false)}>
			<Modal.Header closeButton>
			  <Modal.Title></Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<iframe src={getPdf} width="100%" style={{height:"500px"}}></iframe>				
			</Modal.Body>
			<Modal.Footer>
			  <Button variant="danger" onClick={()=>setShowModal(false)}>
				بستن
			  </Button>
			</Modal.Footer>
			</Modal>			
        </div>
    );
}
